import React from 'react';
import { Row, Typography } from 'components';
import { Button } from 'antd';
import { CopiedIcon } from 'components/common/icons/contactFieldManagerIcons/CopiedIcon';
import { CopyIcon } from 'components/common/icons';
import { useWebsitePricingCard } from 'feature/brandTabs/pricingAndSuppliers/pricing/useWebsitePricingCard';
import styles from './../styles.module.scss';

export const WebsitePricingCard = React.memo((props: { website: string }) => {
  const { website } = props;
  const { onCopy, copyStatus } = useWebsitePricingCard();
  return (
    <Row className={styles.card} align={'middle'} justify={'space-between'} wrap={false}>
      <Button
        className={styles.link_btn}
        block
        size={'small'}
        type="link"
        href={website?.startsWith('http') ? website : `https://${website}`}
        target="_blank"
      >
        <Typography.Text title={website} className={styles.cut_long_text}>
          {website}
        </Typography.Text>
      </Button>
      <Button style={{ padding: 0, height: 16 }} type={'link'} onClick={() => onCopy(website)} size={'small'}>
        {copyStatus[website] ? <CopiedIcon color={'#0D6EFD'} /> : <CopyIcon color={'#0D6EFD'} />}
      </Button>
    </Row>
  );
});
